/* eslint-disable no-fallthrough */
import { ProjectUtil } from "imagica-corekit/dist/cases/util/ProjectUtil";
import store from "@store/index";
import func from "@uikit/func";
import { useDispatch } from "react-redux";
import { editorActions } from "@store/editor";
import { getIt } from "@uikit/getIt";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { distance } from "./homeConst";
import { CreatorStoreMethods } from "@uikit/service/CreatorStoreMethods";
import { defaultApis } from "@views/thinking-layout-editor/nodeTypeComponents/nodeTypeDispose";
import { GROUPID_REG } from "@views/thinking-layout-editor/constants";
import { getAutomaticDisplayType } from "@views/thinking-layout-editor/util";
import { CustomEdgeUtil } from "@uikit/util/CustomEdgeUtil";
import useNewEdgeRun from "@uikit/hooks/useNewEdgeRun";
import useRunEdgeAddNodeToPreview from "@custom-hooks/useRunEdgeAddNodeToPreview";
import { logEvent } from "@uikit/service/amplitude";
import { useHomeServices } from "./useHomeServices";
import { AppSnapshotService } from "@uikit/service/AppSnapshotService";
import { useSearchParams } from "react-router-dom";
import { projectPageStore } from "./store/ProjectPageStore";
import { ShareAppManager } from "./manager/ShareAppManager";
import { creatorRefStore } from "./store/CreatorRefStore";
import { projectRunStore } from "./store/ProjectRunStore";
import { newOnboardingFlowStore } from "./store/NewOnboardingFlowStore";
import { CreatorAISaasStore } from "./store/CreatorAISassStore";
import { CreatorSaasAppStore } from "./store/CreatorSaasAppStore";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { CreatorEdgesStore } from "@uiview/views/ProjectCanvas/store/CreatorEdgesStore";
import { HomeMethodsService } from "@uikit/service/HomeMethodsService";
import { HomeMethodsUtil } from "@uikit/util/_homeUtil";
import { CanvasDataRef } from "@uikit/model/CanvasDataRef";

export type HomeRunProps = {
  getSaveDataV3: any;
  handleCustomToGroup: any;
  handleGroupToCustom: any;
  handleSave: any;
  handleInputField: any;
};

// eslint-disable-next-line
export function useHomeRun(useProps: { runProps: HomeRunProps }) {
  const homeStore = getIt(HomeStore);
  const creatorAISassStore = getIt(CreatorAISaasStore);
  const creatorSaasAppStore = getIt(CreatorSaasAppStore);
  const creatorNodesStore = getIt(CreatorNodesStore);
  const creatorEdgesStore = getIt(CreatorEdgesStore);
  const canvasDataRef = getIt(CanvasDataRef);
  const homeMethods = getIt(HomeMethodsService);

  const shareAppManager = ShareAppManager.use();

  const { groupPostApi } = useHomeServices();

  const dispatch = useDispatch();

  const setNeedDisableEdgeIds = (val: string[]): void => {
    dispatch(editorActions.setNeedDisableEdgeIds(val));
  };

  const creatorStoreMethods = getIt(CreatorStoreMethods);

  const { firstRunAllAddNodeToPreview } = useRunEdgeAddNodeToPreview({
    handleInputField: useProps.runProps.handleInputField,
    setInputId: creatorAISassStore.setInputId,
  });

  const { corekitRun } = useNewEdgeRun({
    getSaveData: useProps.runProps.getSaveDataV3,
    handleCustomToGroup: useProps.runProps.handleCustomToGroup,
    errorClosure: () => {
      projectRunStore.setRunAllLoading(false);
    },
    handleGroupToCustom: useProps.runProps.handleGroupToCustom,
    handleSave: useProps.runProps.handleSave,
  });

  const [searchParams] = useSearchParams();
  // conts
  //==== functions

  const handelGroupNode = (edge: {
    source: string | undefined;
    target: string | undefined;
    data: { lineParam: { enterText: string } };
  }): { targetArr: any; sourceArr: any } => {
    const sourceArr = creatorNodesStore.getNodes().filter(n => n.parentNode === edge.source) || [];
    const targetArr = creatorNodesStore.getNodes().filter(n => n.parentNode === edge.target) || [];
    //按Y轴排序
    sourceArr.sort((a, b) => a.position.y - b.position.y);
    targetArr.sort((a, b) => a.position.y - b.position.y);

    //给child node赋值
    const sourceLen = sourceArr.length;
    const targetLen = targetArr.length;
    let result = {
      sourceArr,
      targetArr: targetArr.slice(0, sourceLen),
    };

    if (sourceLen === targetLen) {
      return result;
    } else if (sourceLen < targetLen) {
      //删除多余的node
      // source nodes数量比target少
      // TODO: Hardcoded
      const funcName = edge?.data?.lineParam?.enterText.replace("/", "");
      const builtInFunctionObj = defaultApis.find(x => x.label === funcName);
      const type = builtInFunctionObj?.value || funcName;
      const isShowStockInterface = type === "showStockInterface";
      if (!isShowStockInterface) {
        const moreChildNode = (targetArr.slice(sourceArr.length) || []).map(x => x.id);
        creatorNodesStore.setNodes(prevList => prevList.filter(x => !moreChildNode.includes(x.id)));
      }
    } else {
      // source nodes比target多
      const newNodes = [] as any[];
      const sliceLevel = targetArr[0]?.data?.sliceLevel || 1;
      const targetGroup = creatorNodesStore.getNodes().find(x => x.id === edge.target);
      let targetChildNode = targetGroup?.data?.childNode || [];
      const targetId = targetArr.map(x => x.id);
      targetChildNode = Array.from(new Set([...targetChildNode, ...targetId]));
      for (let i = targetLen; i < sourceLen; i++) {
        let newNodeId = "";

        if (!func.isEmpty(targetChildNode[i])) {
          newNodeId = targetChildNode[i];
        } else {
          newNodeId = `editor-${creatorRefStore.nodeIndexRef.current++}`;
          targetChildNode.push(newNodeId);
        }
        const newNode = {
          id: newNodeId,
          type: "customNode",
          parentNode: edge.target,
          extent: "parent",
          data: {
            ...canvasDataRef.nodeDataRef.current,
            textAreaValue: "",
            sliceLevel,
            isSliceNode: true,
            parentNodeId: edge.target,
          },
          position: {
            x: 2 * distance,
            y: distance * (i + 1) + i * 200,
          },
        };
        newNodes.push(newNode);
      }
      creatorNodesStore.setNodes(prevList => [...prevList, ...newNodes]);
      creatorNodesStore.setNodes(prevList => {
        return prevList.map(pre => {
          if (pre.id === edge.target) {
            return {
              ...pre,
              data: {
                ...pre.data,
                childNode: targetChildNode,
              },
            };
          }
          return pre;
        });
      });
      result = { sourceArr, targetArr: [...targetArr, ...newNodes] };
    }

    return result;
  };

  const handleApiCall = async (sourceNodes: any[]): Promise<void> => {
    if (func.isEmpty(sourceNodes)) return;
    // 当前sourceNodes对应的targetNodes
    let targetNodeIds = [] as any[];
    const apiArr = [] as any[];
    // 如果当前sourceNodes包含group，则需要查找出来当前group下面所有有边的nodes
    const sourceGroups = sourceNodes.filter((x: { id: any }) => GROUPID_REG.test(x.id));
    if (!func.isEmpty(sourceGroups)) {
      const currGroupNodes = creatorNodesStore
        .getNodes()
        .filter(x => sourceGroups.some((y: { id: any }) => x.parentNode === y.id));
      const hasEdgeNodes = currGroupNodes.filter((x: { id: any }) =>
        creatorEdgesStore.getEdges().filter(y => y.source === x.id)
      );
      sourceNodes = [...sourceNodes, ...hasEdgeNodes];
    }

    sourceNodes.forEach((x: { id: any; data: { textAreaValue: any } }) => {
      let currSourceEdges = creatorEdgesStore.getEdges().filter(y => y.source === x.id) as any[];
      // 过滤掉 disabledRun 的 edge
      currSourceEdges = currSourceEdges.filter(item => !item.data.lineParam.disabledRun);
      if (func.isEmpty(currSourceEdges)) return;
      targetNodeIds = [...targetNodeIds, ...currSourceEdges.map(y => y.target)];
      currSourceEdges.forEach(y => {
        if (y.data.isCreatedBySlice) {
          homeMethods.handleSlice(x, y.target);
        } else if (GROUPID_REG.test(y.source)) {
          const { sourceArr, targetArr } = handelGroupNode(y);
          // bsf-2176 当 lineType 为 identifier 时, 过滤掉没用的边
          if (!CustomEdgeUtil.hasRunWithLineParam(y.data.lineParam)) {
            return;
          }
          sourceArr.forEach((source: any, index: number) => {
            const targetNode = targetArr[index];
            apiArr.push({
              sourceEdgeId: y.id,
              // sourceNodeId: y.source,
              sourceNodeId: source.id,
              targetNodeId: targetNode.id,
              textAreaValue: source.data.textAreaValue,
              lineParam: Object.assign({}, y.data.lineParam, { isFromGroup: true }),
              source: y.source,
              target: y.target,
              id: y.id,
            });
          });
        } else {
          // bsf-2176 当 lineType 为 identifier 时, 过滤掉没用的边
          if (!CustomEdgeUtil.hasRunWithLineParam(y.data.lineParam)) {
            return;
          }
          apiArr.push({
            sourceEdgeId: y.id,
            sourceNodeId: y.source,
            targetNodeId: y.target,
            textAreaValue: x.data.textAreaValue,
            lineParam: y.data.lineParam,
          });
        }
      });
    });

    if (func.isEmpty(apiArr) && func.isEmpty(targetNodeIds)) return;
    // 分组请求
    await groupPostApi(apiArr, (target: any, tempText: any) => {
      creatorNodesStore.setNodes(prevList => {
        return prevList.map(l => {
          if (l.id === target) {
            // 自动判定获取内容 displayType
            const displayType = getAutomaticDisplayType(l.data, tempText);
            return {
              ...l,
              data: {
                ...l.data,
                textAreaValue: tempText.trim(),
                displayType: displayType,
              },
            };
          }
          return l;
        });
      });
    });

    const targetNodes = creatorNodesStore.getNodes().filter(x => targetNodeIds.includes(x.id));
    // 递归调用
    await handleApiCall(targetNodes);
  };

  const multipleInputsEdges = (sourceNodes: any[]): any[] => {
    const targetIdArr: { sourceId: any; targetId: any }[] = [];
    // eslint-disable-next-line array-callback-return
    sourceNodes.map((x: { id: any }) => {
      const targetId = creatorStoreMethods.getTargetNodeId(x.id);
      // 过滤出目标相同的 input 只取第一个
      if (!func.isEmpty(targetId) && !targetIdArr.some(y => y.targetId === targetId)) {
        return targetIdArr.push({
          sourceId: x.id,
          targetId,
        });
      }
    });
    return sourceNodes.filter((x: { id: any }) => targetIdArr.some(y => y.sourceId === x.id));
  };

  const getSimpleNodeData = (node: any): any => {
    const simpleNodeData = {} as any;
    Object.keys(canvasDataRef.nodeDataRef.current).forEach(x => {
      if (typeof canvasDataRef.nodeDataRef.current[x] !== "function") {
        simpleNodeData[x] = node.data[x];
      }
    });
    return simpleNodeData;
  };

  const clickRunAllBtn = async (sourceNodeArr: any, isFromPreview = false): Promise<void> => {
    creatorRefStore.prevRunAllNodesContent.current = creatorNodesStore.getNodes().map(x => ({
      id: x.id,
      textAreaValue: x.data.textAreaValue,
      displayType: x.data.displayType,
    }));
    //使用corekit的run
    if (creatorRefStore.isNewEdgeRunRef.current) {
      /// 检查有input为空的话，不run并提示
      const emptyInput = ProjectUtil.emptyInput(
        store.getState().studio.selectedTemplate,
        creatorEdgesStore.getEdges(),
        store.getState().fot.variableList,
        useProps.runProps.getSaveDataV3
      );
      const emptyAddDataSource = ProjectUtil.emptyAddDataSourceParams(
        creatorNodesStore.getNodes(),
        creatorSaasAppStore.state.saasUIData?.input,
        isFromPreview
      );

      if (emptyAddDataSource) {
        func.customMsg({
          content: "Need Add Data Source",
          type: "warning",
        });
        return;
      }
      if (emptyInput && !isFromPreview) {
        func.customMsg({
          content: "Need input value",
          type: "warning",
        });
        return;
      }

      const customNewEdgeArr = creatorNodesStore
        .getNodes()
        .filter(x => x.type === "customNewEdge")
        .map(x => x.id);
      setNeedDisableEdgeIds(customNewEdgeArr);
      try {
        projectRunStore.setRunAllLoading(true);
        // FIXME: run 结束时机不对
        await corekitRun({
          getSimpleNodeData,
          isFromPreview,
          isRunAll: true,
          onUpdateNode: shareAppManager.setRunAllUpdateData,
        });

        // run all完的时候重置group折叠状态
        homeStore.cleanGroupCOEData();

        creatorNodesStore.setNodes(l => {
          return l.map((x: any) => {
            if (x.type === "customNode") {
              return {
                ...x,
                data: {
                  ...x.data,
                  showGroupCollapseData: false,
                },
              };
            }
            return x;
          });
        });
        firstRunAllAddNodeToPreview(customNewEdgeArr[0]);
        creatorStoreMethods.onNodeContentChange(
          HomeMethodsUtil.getStartEndNodesContentArr(
            creatorRefStore.prevRunAllNodesContent.current,
            undefined,
            creatorNodesStore.state.nodes
          )
        );
        // save app snapshot TODO: extract hook
        const data = useProps.runProps.getSaveDataV3(
          store.getState().studio.selectedTemplate,
          creatorEdgesStore.getEdges(),
          store.getState().fot.variableList,
          {}
        );
        const appMetadata = store.getState().editor.subscriberParamsData as any;
        data.index = appMetadata.guest_user_key || appMetadata.attributes?.guest_user_key;
        data.app_session_id = searchParams.get("app_session_id"); // TODO: get from encoded
        const snapsotService = new AppSnapshotService();
        snapsotService.buildProjectData(data).createAppSnapshot();
      } catch (error) {
        console.error(error);
      } finally {
        projectRunStore.setRunAllLoading(false);
        newOnboardingFlowStore.showNewOnboardingFlowTips(creatorNodesStore.getNodes);
      }
      const eventProperties = {
        source_nodes: sourceNodeArr,
      };
      logEvent("run_all", eventProperties);
      return;
    }
    try {
      projectRunStore.setRunAllLoading(true);
      // 过滤掉由切片创建的边
      let sourceNodes = creatorNodesStore
        .getNodes()
        .filter(
          x =>
            !creatorEdgesStore.getEdges().some((y: { target: string }) => y.target === x.id) &&
            func.isEmpty(x.parentNode)
        );
      sourceNodes = multipleInputsEdges(sourceNodes);

      await handleApiCall(sourceNodeArr || sourceNodes);
      // 清空 disable 选中数据
      projectPageStore.setAlreadyRunArr([]);
      setNeedDisableEdgeIds([]);
      creatorStoreMethods.onNodeContentChange(
        HomeMethodsUtil.getStartEndNodesContentArr(
          creatorRefStore.prevRunAllNodesContent.current,
          undefined,
          creatorNodesStore.state.nodes
        )
      );
      const eventProperties = {
        source_nodes: sourceNodeArr || sourceNodes,
      };
      logEvent("run_all", eventProperties);
    } finally {
      projectRunStore.setRunAllLoading(false);
    }
  };

  return {
    clickRunAllBtn,
  };
}
